import React from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

const InfoTooltip = ({ title, text }) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="relative inline-flex items-center justify-center h-5 w-5 text-primary hover:text-primary/80 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-full"
            aria-label={title || "Information"}
          >
            <span className="absolute inline-flex h-full w-full rounded-full bg-primary/20 animate-ping opacity-60" />
            <Info className="h-4 w-4 relative z-10" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="left" className="max-w-[260px]">
          {title && (
            <p className="font-semibold text-xs mb-1 text-primary">{title}</p>
          )}
          <p className="text-xs leading-relaxed">{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InfoTooltip;
